import React from 'react';
import { LocationOutlineIcon } from '@cp/ds/src/icons';
import { Typography } from '@cp/ds/src/components/typography';
import { SxProps } from '@cp/ds';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { Stack } from '@cp/ds/src/components/stack';
import { RoutedLink } from 'src/shared/ui/link';

export interface CitiesListLinkProps {
  sx?: SxProps;
}

export const CitiesListLink = React.forwardRef<HTMLSpanElement, CitiesListLinkProps>(({ sx }, ref) => {
  const resolver = useClientWebResolver();

  return (
    <Stack alignItems="center" component="span" direction="row" pl={1.5} ref={ref} sx={sx}>
      <LocationOutlineIcon />

      <RoutedLink href={resolver.resolve({ page: ClientWebPage.Cities })}>
        <Typography variant="body bold">Все города</Typography>
      </RoutedLink>
    </Stack>
  );
});
